<form [formGroup]="frm">
    <div class="grid">
        <div class="col-6">
            <label>Nome</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="name">
        </div>
        <div class="col-6">
            <label>Codice</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="code">
        </div>
        <div class="col-6">
            <label>Paese</label>
            <div class="mt-1">
                <p-autoComplete [forceSelection]="true" formControlName="country_iso"
                    [suggestions]="suggestedCountries"
                    (completeMethod)="filterCountries($event)" field="name" dataKey="ISO"
                    class="frm" appendTo="body"
                    [emptyMessage]="'Nessun risultato trovato'"></p-autoComplete>
            </div>
        </div>
        <div class="col-6">
            <label>Tipo</label>
            <div class="mt-1">
                <p-dropdown [options]="types" optionValue="name" optionLabel="name" formControlName="type" appendTo="body"></p-dropdown>
            </div>
        </div>
    </div>
</form>

<div class="modal-footer flex justify-content-between">
    <div class="w-full">
        <p-button label="Annulla" size="small" (click)="close()" [outlined]="true"></p-button>
    </div>
    <div class="w-full ml-3">
        <p-button label="Salva" size="small" (click)="save()" styleClass="slide-o"></p-button>
    </div>
</div>
